import { Injectable } from '@angular/core';
import { AuthpermissionsService } from '../auth/authpermissions.service';
import { FuseNavigationItem } from '../../../@fuse/components/navigation';

@Injectable({ providedIn: 'root' })
export class NavigationPermissionService {

    filter(
        navigation: FuseNavigationItem[],
        userPermissions: string[]
    ): FuseNavigationItem[] {

        return navigation
            .map(item => this.filterItem(item, userPermissions))
            .filter((item): item is FuseNavigationItem => !!item);
    }

    private filterItem(
        item: FuseNavigationItem,
        userPermissions: string[]
    ): FuseNavigationItem | null {

        // 1️⃣ Validar permiso del item (si existe)
        if (item.meta?.permissions?.length) {
            const hasPermission = item.meta.permissions.some(p =>
                userPermissions.includes(p)
            );

            if (!hasPermission) {
                return null;
            }
        }

        // 2️⃣ Si tiene hijos → filtrar hijos
        if (item.children?.length) {
            const children = item.children
                .map(child => this.filterItem(child, userPermissions))
                .filter((child): child is FuseNavigationItem => !!child);

            // 3️⃣ Si es collapsable y no tiene hijos visibles → ocultar
            if (!children.length && item.type === 'collapsable') {
                return null;
            }

            return { ...item, children };
        }

        return item;
    }
}

